// removed by extract-text-webpack-plugin
module.exports = {"sideToolbar":"GA3hZFNSHEcfwSaHtx4r_","toolbar":"_3oZsHMTqFDE1xjk7k9L-GZ","toolbarIcons":"_3DKhWE-hJGXQM7Ct0bN5vh","toolbarIcon":"gfppcomy3mmYxeu3j0eB5"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/RichEditor/components/Toolbars.scss
// module id = 183
// module chunks = 0